import PublicRoutes from "./routes/PublicRoutes";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap";
import "../src/assets/css/style.css";
import { useEffect } from "react";


function App() {
	
	return (
		<>
		
			<PublicRoutes />
		</>
	);
}

export default App;
